// CandidateReservationDetails_new.jsx migration (Phase E). Keys ordered to match the file's own
// reading order: page heading, Card 1 (Category, Caste & Fees Details: dropdown/input headings,
// placeholder, Non-Creamy Layer certificate checkbox), Card 2 (Reservation / Age Relaxation Details:
// the 6 reservation checkboxes), then the Cancel/Previous/Save action buttons, then the 3
// validate()-driven setState error messages in the order they occur.
//
// Every entry below was already bilingual (English + Marathi) somewhere in the file — extraction
// only, zero new translation authored — EXCEPT selectCategoryPlaceholder and the 3 validation error
// messages, which had no existing Marathi anywhere in the file; those are marked
// "AI-authored, needs linguistic QA" and reuse this same file's own existing terminology
// (श्रेणी / जात / नॉन क्रिमीलेअर) wherever a matching term already appears elsewhere in the file.
export default {
  // Page heading — extraction.
  pageHeading: { en: 'Reservation Details', mr: 'आरक्षण तपशील' },

  // Card 1 header — extraction.
  categoryCasteFeesHeading: { en: 'Category, Caste & Fees Details', mr: 'श्रेणी, जात आणि फी तपशील' },

  // Category dropdown — heading is an extraction; the placeholder had no existing Marathi anywhere
  // in the file. AI-authored, needs linguistic QA.
  categoryLabel: { en: 'Category', mr: 'श्रेणी' },
  selectCategoryPlaceholder: { en: 'Select Category', mr: 'श्रेणी निवडा' }, // AI-authored, needs linguistic QA

  // Caste input — extraction.
  casteLabel: { en: 'Caste', mr: 'जात' },

  // Fees (read-only) input — extraction.
  feesLabel: { en: 'Fees', mr: 'शुल्क' },

  // Non-Creamy Layer certificate checkbox — extraction.
  nonCreamyLayerCertificateLabel: {
    en: 'Do you have Updated Non-Creamy Layer Certificate?',
    mr: 'तुमच्याकडे अद्यावत नॉन क्रिमीलेअर प्रमाणपत्र आहे का?'
  },

  // Card 2 header — extraction.
  ageRelaxationHeading: { en: 'Reservation / Age Relaxation Details', mr: 'आरक्षण / वय शिथील तपशील' },

  // Card 2's 6 reservation checkboxes — all extractions.
  exServicemanLabel: { en: 'Ex Serviceman', mr: 'माजी सैनिक' },
  ladiesLabel: { en: 'Ladies', mr: 'महिला' },
  handicapedLabel: { en: 'Handicaped', mr: 'अपंग' },
  earthQuakeAffectedLabel: { en: 'Earth Quake Affected', mr: 'भुकंपग्रस्त' },
  playerLabel: { en: 'Player', mr: 'खेळाडू' },
  anshkalinLabel: { en: 'Anshkalin', mr: 'अंशकालीन' },

  // Action buttons — all extractions.
  cancelButton: { en: 'Cancel', mr: 'रद्द करा' },
  previousButton: { en: 'Previous', mr: 'मागे' },
  saveButton: { en: 'Save', mr: 'जतन करा' },

  // validate() error messages — English-only in the file today. AI-authored, needs linguistic QA.
  categoryRequiredError: { en: 'Please Select Category', mr: 'कृपया श्रेणी निवडा' }, // AI-authored, needs linguistic QA
  casteRequiredError: { en: 'Please Enter Valid Caste', mr: 'कृपया वैध जात प्रविष्ट करा' }, // AI-authored, needs linguistic QA
  nonCreamyLayerRequiredError: { en: 'NonCreamyLayer Required', mr: 'नॉन क्रिमीलेअर आवश्यक आहे' } // AI-authored, needs linguistic QA
};
